import {Fragment} from "react";

const STEP_LABELS = ["Upload CSV", "Review report", "Confirm", "Result"] as const;

type BulkDeleteStepperProps = {
  readonly currentStep: number;
};

const BulkDeleteStepper = (props: BulkDeleteStepperProps): JSX.Element => {
  const {currentStep} = props;

  return (
    <div className="bulk-delete-stepper" aria-hidden="true">
      {STEP_LABELS.map((label, index) => {
        const stepNumber = index + 1;
        const stateClass = stepNumber < currentStep ? "done" : stepNumber === currentStep ? "active" : "";
        return (
          <Fragment key={label}>
            {index > 0 && <div className={`bulk-delete-step-line ${stepNumber <= currentStep ? "done" : ""}`} />}
            <div className={`bulk-delete-step ${stateClass}`}>
              <span className="bulk-delete-step-num">{stepNumber}</span>
              <span className="bulk-delete-step-label">{label}</span>
            </div>
          </Fragment>
        );
      })}
    </div>
  );
};

export default BulkDeleteStepper;
